
import React, { useEffect, useState} from "react";
import { AgGridReact } from "ag-grid-react";
import { getexceptionnotify, getExceptionNotifCategories,insertOrUpdateNotifType} from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { useParams } from "react-router-dom";
import { SBADropDown, SBAMultiSelectCheck, SBAComboBox } from "../../UiComponents/SBADropDown";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer, toast } from 'react-toastify';
export const MonitoringNotificationDetails = () => {    
    const [data, setdata] = useState([]);
    const [show, setShow] = useState(false);
    const [NotifCategories, setNotifCategories] = useState([]);
    const [selectedNotifCategories, setselectedNotifCategories] = useState([]);
    const [description, setdescription] = useState("");
    const [Subject, setSubject] = useState("");
    const [Message, setMessage] = useState("");
    const [selectedLinking, setselectedLinking] = useState("");
    const [selectedTime, setselectedTime] = useState("");
    const [selectedSeverity, setselectedSeverity] = useState("");
    const [selectedGroup, setselectedGroup] = useState(null);
    const [selectedNotifytyeId, setselectedNotifytyeId] = useState([]);
    const param=useParams();
    useEffect(() => {
        Getnotifydetails();
        GetExceptionNotifCategories();
    },[])
    const Getnotifydetails = async ()  => {
        try {
            const response = await sbaAxios({

                url: `${getexceptionnotify}?exceptionNotifTypeId=${null}`,
                method: 'get',
            })
            if (response)
            {
                setdata(response);
            }
        }
        catch (error) {

        }

    }
    const defaultColDef = {
        sortable: false,
        floatingFilter: true,
        suppressMovable: true,
        flex: 1,
        resizable: true,
        autoHeaderHeight: true,
    };
    const GetExceptionNotifCategories = async () => {
        try {
            const response = await sbaAxios({

                url: `${getExceptionNotifCategories}`,
                method: 'get',
            })
            if (response) {
                setNotifCategories(response);
            }
        }
        catch (error) {

        }

    }
    const ExceptionNotifySave = async () => {
        let issave = true;
        const savedata = {
            exceptionNotifTypeId: selectedNotifytyeId,
            exceptionNotifCategoryId: selectedNotifCategories?.ExceptionNotifCategoryId,
            description: description || "",
            subject: Subject || "",
            message: Message || "",
            hyperlink: selectedLinking || "",
            timeToLive: selectedTime || 0,
            severity: selectedSeverity || 0,
            groupResults: parseInt(selectedGroup) || 1
        }; 
        if (!selectedNotifytyeId) {
            issave = false;
            
        }
        if (!selectedNotifCategories) {
            issave = false;
            SBNotify({ Msg: "Please Select Exception Notification Categories", type: "error" });
        }

        if (issave) {
            try {
                const res = await sbaAxios({
                    url: insertOrUpdateNotifType,
                    method: "post",
                    data: savedata
                });
                if (res)
                SBNotify({ Msg: "Exception Notify update Successfully", type: "success" });
                Getnotifydetails();
                setShow(false);
               
            } catch (error) {
                console.error("Axios error:", error);
                SBNotify({ Msg: "Network Error: " + error.message, type: "error" });
            }
        }
    };
    const ActionRenderer = (props) => {
        const Editdatas = props.data;
        const handleEditClick = () => {
            setShow(true);
            setselectedNotifytyeId(Editdatas.ExceptionNotifTypeId)
            setselectedNotifCategories({ "ExceptionNotifCategoryId": Editdatas.ExceptionNotifCategoryId, "ExceptionNotifCategoryName": Editdatas.ExceptionNotifCategoryName });
            setdescription(Editdatas.Description);
            setSubject(Editdatas.Subject);
            setMessage(Editdatas.Message);
            setselectedLinking(Editdatas.Hyperlink);
            setselectedTime(Editdatas.TimeToLive);
            setselectedSeverity(Editdatas.Severity);
            setselectedGroup(Editdatas.GroupResults);
            
        };
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-edit"
                    style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleEditClick}
                ></i>
            </div>
        );
    };

    const ColumnDefs = [
        { headerName: 'Exception Category', field: 'ExceptionNotifCategoryName' , filter: "agTextColumnFilter"},
        {
            headerName: 'Description',
            field: 'Description',
            filter: "agTextColumnFilter",

        },
        {
            headerName: 'Subject',
            field: 'Subject',
            filter: "agTextColumnFilter",

        },
        {
            headerName: 'HyperLink',
            field: 'Hyperlink',
            filter: "agTextColumnFilter",

        },
        {
            headerName: 'Time to Live',
            field: 'TimeToLive',
            filter: "agTextColumnFilter",
        },
        {

            headerName: 'Action',
            field: 'Action',
            cellRenderer: ActionRenderer,
            floatingFilter: true,


        }
    ];
    return <>
        <div >
            <div className="">
                            <div className="ag-theme-alpine mt-3" style={{ height: "50vh", width: "70%" }}>
                                <AgGridReact rowData={data} columnDefs={ColumnDefs} defaultColDef={defaultColDef}/>
                            </div>       
               </div>

            <SBADrawer
                open={show}
                setOpen={setShow}
                close={false}
                title={" Edit Exception Notify"}
            >
                <div className="drawer">
                    <div>
                        <div className="col-lg-12 px-0">
                            <div className="row m-2">
                                <div className="row mb-4">
                                    <label className="header-container m-1">Notifications</label>

                                    <div>
                                        <SBAComboBox
                                            className="w-75"
                                            data={NotifCategories}
                                            textField={"ExceptionNotifCategoryName"}
                                            valueField={"ExceptionNotifCategoryId"}
                                            value={selectedNotifCategories}
                                            onChange={(e) => { setselectedNotifCategories(e.value) }}
                                            placeholder="---Please Select---"
                                            popupSettings={{ className: "modalDD" }}

                                        />
                                    </div>
                                </div>

                                <div className="row mb-4">

                                    <label className="header-container m-1">
                                        Description
                                          </label>
                                    <div>
                                        <input
                                            className="form-control w-75"
                                            type="text"
                                            value={description}
                                            onChange={(e) => setdescription(e.target.value)}

                                        />
                                    </div>

                                </div>
                                <div className="row mb-4">

                                    <label className="header-container m-1">Subject</label>
                                    <div className="d-flex gap-2">
                                        <input
                                            className="form-control w-75"
                                            type="text"
                                            value={Subject}
                                            onChange={(e) => setSubject(e.target.value)}

                                        />
                                    </div>

                                </div>
                                <div className="row mb-4">
                                    <label className="header-container m-1">
                                        Message
                                          </label>
                                    <div>
                                        <textarea id="txtNote" className="form-control w-75" rows={4}
                                            onChange={(e) => setMessage(e.target.value)}
                                            value={Message}
                                        >
                                        </textarea>
                                    </div>

                                </div>

                                <div className="row mb-4">

                                    <label className="header-container m-1">
                                        Hyper Link
                                          </label>
                                    <div>
                                        <input
                                            className="form-control w-75"
                                            type="text"
                                            value={selectedLinking}
                                            onChange={(e) => setselectedLinking(e.target.value)}
                                        />
                                    </div>                                   
                                </div>
                                <div className="row mb-4">

                                    <label className="header-container m-1">
                                        Time to Live
                                          </label>
                                    <div>
                                        <input
                                            className="form-control w-75"
                                            type="number"
                                            value={selectedTime}
                                            onChange={(e) => setselectedTime(e.target.value)}

                                        />
                                    </div>                                    
                                </div>

                                <div className="row mb-4">

                                    <label className="header-container m-1">
                                        Severity
                                          </label>
                                    <div>
                                        <input
                                            className="form-control w-75"
                                            type="number"
                                            value={selectedSeverity}
                                            onChange={(e) => setselectedSeverity(e.target.value)}

                                        />
                                    </div>                                    
                                </div>
                                <div className="row mb-4">

                                    <label className="header-container m-1">
                                       Group Result
                                          </label>
                                    <div>
                                        <input
                                            className="form-control w-75"
                                            type="number"
                                            value={selectedGroup}
                                            onChange={(e) => setselectedGroup(e.target.value)}

                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="mt-5">
                            <button className="s-sm-btn mx-1" onClick={() => {
                                setShow(false);
                            }}>
                                Cancel
                            </button>
                            <button className="p-sm-btn mx-1" onClick={ExceptionNotifySave}>
                                Save
                           </button>
                        </div>
                    </div>
                </div>
            </SBADrawer>
            {/*<ToastContainer></ToastContainer>*/}
         </div>
        </>
}
